import styled, { css } from 'styled-components';
import { getColor, typeScale, StyleVars } from 'core/utils';


export const Wrapper = styled.div`
	color: ${getColor("gold")};
	font-size: ${typeScale(2)};
	font-weight: 600;
	letter-spacing: 0.2px;
	white-space: nowrap;
	display: flex;
	align-items: center;

	@media (max-width: ${StyleVars.screenXsm}) {
		margin: 5px 0px 0px;
	}

	${props => !props.stacked && css`
		display: flex;
		align-items: center;
		line-height: 24px;
		height: 24px;
	`}

	${props => props.stacked && css`
		margin-top: ${typeScale(2)};
		margin-bottom: ${typeScale(4)};
	`}

	${props => props.tiny && css`
		font-size: ${typeScale(1.5)};
		height: ${typeScale(1.5)};
		line-height: ${typeScale(1.5)};
	`}

	svg {
		/* otherwise we have a global style on svg that makes this shrink */
		max-width: none;
		fill: currentColor;
		stroke: currentColor;
	}

	&:active,
	&:focus,
	&:hover {
		color: ${getColor("gold")};
	}
`;

export const ReviewCount = styled.span`
	color: ${getColor("gray11")};
	line-height: 1;
	margin-left: ${typeScale(0.5)};
	font-size: 0.9em;
`;
